import { render, staticRenderFns } from "./newEditAcompanhamentosBimestrais.vue?vue&type=template&id=1bdee5c8"
import script from "./newEditAcompanhamentosBimestrais.vue?vue&type=script&lang=js"
export * from "./newEditAcompanhamentosBimestrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports